import { Gol, LogLevel } from "@bale/gol-logger";
import { isProductionMode } from "./utils";
import { isLocalHost } from "@bale/utils";

const showLogs = !isProductionMode() || isLocalHost();
export class WebLogger {
  static logger = Gol.getInstance(
    showLogs ? LogLevel.Debug : LogLevel.Critical
  );

  public static changeLogLevel = (level: LogLevel): void => {
    WebLogger.logger.changeLevel(level);
  };

  public static getLogger(tag: string) {
    return WebLogger.logger.getLogger(tag);
  }

  public static debug(tag: string, ...args: unknown[]) {
    WebLogger.logger.debug(tag, ...args);
  }
  public static error(tag: string, ...args: unknown[]) {
    WebLogger.logger.error(tag, ...args);
  }
  public static critical(tag: string, ...args: unknown[]) {
    WebLogger.logger.critical(tag, ...args);
  }
  public static warn(tag: string, ...args: unknown[]) {
    WebLogger.logger.warn(tag, ...args);
  }
  public static info(tag: string, ...args: unknown[]) {
    WebLogger.logger.info(tag, ...args);
  }
}
